export const USER = () => `/user/:id`;
export const USERS_TABLE = () => `/users-table`;
